<template>
  <div class="msg-video-reply">
    <div v-for="item in list" :key="item.id">
      <ReplyItem :data="item" />
      <div class="reply-open" @click="handleOpen">
        <span v-show="!isShow">展开{{ item.childComment.length }}条回复</span>
        <span v-show="isShow">收起回复</span>
        <img src="@/assets/img/search-arrow.svg" :class="{ filp: isShow }" />
      </div>
      <div class="reply-sub" v-show="isShow">
        <ReplyItem
          :styleFlag="styleFlag"
          v-for="content in item.childComment"
          :key="content.id"
          :data="content"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ReplyItem from "./components/ReplyItem.vue";
export default {
  name: "Reply",
  components: {
    ReplyItem,
  },
  props: {
    msgBoardList: Array,
  },
  computed: {
    list() {
      return this.msgBoardList;
    },
  },
  data() {
    return {
      styleFlag: false,
      isShow: false,
    };
  },
  methods: {
    handleOpen() {
      this.isShow = !this.isShow;
    },
  },
};
</script>

<style lang="scss">
.msg-video-reply {
  // padding-top: 22px;
  .reply-sub {
    margin-left: 53px;
  }
  .reply-open {
    margin: -20px 0 30px 61px;
    span {
      font-size: 15px;
      color: #7f7f7f;
      margin-right: 8px;
    }
    img {
      width: 12px;
      height: 7px;
    }
  }
  .filp {
    transform: rotateX(180deg) translate(0 -4px);
  }
}
</style>
